<template>
  <div>
    <div class="holds-the-iframe h-100 w-100">
      <vue-pdf-embed ref="pdfRef" :source="newpath" @rendered="handleDocumentRender" />
      <!-- <iframe
          name="iframe"
          src="https://docs.google.com/gview?url=https://apiksa.empirecinemas.com.sa/VipFnBPdf/2/S2715VPA6&embedded=true"
          width="100%"
          height="600px"
          frameborder="0"
        ></iframe> -->
    </div>
  </div>
</template>
<script>
import { makeRequest, makeRequestBrij } from '@/helper/internet.js'
import { groupBy } from 'lodash'
import { EventBus } from '@/main'
import axios from 'axios'
import { URL_BASE } from '@/helper/constant'
import { BASEURL_BRIJ, ImageS3URL } from '@/config/index'
import {
  LanguageService,
  CountryService,
  TokenService,
} from '@/services/storage.service'
// import pdf from "vue-pdf";
// import VuePDFViewer from "vue-pdf-viewer";

import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  components: {
    VuePdfEmbed,
    // pdf,
    // "vue-pdf-viewer": VuePDFViewer,
  },
  data () {
    return {
      getpdfData: [],
      errorMessage: '',
      fullpath: `${ImageS3URL}S3/uploads/1672820333952-final_menu_for_qr_dec_22.pdf`,
      newpath: '',
      page: null,
      pageCount: 1,
      showAllPages: true,
    }
  },
  watch: {
    showAllPages () {
      this.page = this.showAllPages ? null : 1
    },
  },
  beforeMount () {
    this.getPdfData()
  },
  methods: {
    handleDocumentRender () {
      this.hideLoading()
      this.pageCount = this.$refs.pdfRef.pageCount
    },
    getPdfData () {
      this.showLoading()
      let payload = {}
      makeRequestBrij(`/api/admin/get_vip_fnb`, 'GET', null, payload)
        .then(response => {
          const {
            res: { data },
          } = response
          this.getpdfData = []
          this.hideLoading()
          console.log(data, 'from here')
          if (data.Records.length > 0) {
            console.log(data.Records, 'rtehjgfh')
            this.getpdfData = data.Records
            this.newpath = data.Records[0].vip_path
            // this.SuccessMessage = res.data.message;
          } else {
            this.errorMessage = data.message
          }
        })
        .catch(error => {
          console.log('Error', error)
          this.errorMessage = error
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/vipfnbmenue.vue